import _ from 'lodash'

const getCurrentPath = (currentFolder, folders) => {
  if (currentFolder === null) return [null]
  return _.concat(getCurrentPath(_.find(folders, x => x._id === currentFolder).parent, folders), currentFolder)
}

export default getCurrentPath
